import { useGetStandardOrder } from "app/hooks/shared/standard-product/useGetStandardOrder";
import CheckoutPanelDatePickerHeader from "entities/checkout/standard-product-date-picker-header";
import { useCallback, useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton";
import Card from "shared/ui/card";
import { getLocalDateString } from "shared/utils/date";
import CheckoutPanelShipmentDeliveryDatePicker, {
  BumbalType,
} from "widgets/checkout/standard-product-date-picker/standard-product-shipment-delivery-date-picker";
import { AlreadyPlannedHeader } from "./AlreadyPlannedHeader";
import { StandardOrderAppointmentFooter } from "./StandardOrderAppointmentFooter";
import { StandardProductRecommendations } from "./StandardProductRecommendations";

const doneStatusCodes = ["placement_planned", "shipment_planned"];

export const StandardOrderAppointmentPage = ({
  standardOrderId,
  bumbalType,
}: {
  standardOrderId: string;
  bumbalType: BumbalType;
}) => {
  const [date, setSelectedDate] = useState<Date | null>(null);
  const { data: standardOrder, isLoading } =
    useGetStandardOrder(standardOrderId);

  //Stable reference to set date function
  const setDate = useCallback((date: Date | null) => {
    setSelectedDate(date);
  }, []);

  const dateCalculated = useMemo(() => {
    return date ? new Date(date) : null;
  }, [date]);

  // SelectedDate
  const selectedDateProp = dateCalculated;

  // Format the date
  const formattedDate = useMemo(() => {
    return dateCalculated
      ? getLocalDateString(dateCalculated)
      : "Geen datum gekozen";
  }, [dateCalculated]);

  const bumbalStatus = standardOrder?.status ?? "";
  const bumbalAlreadyPlanned = doneStatusCodes.includes(bumbalStatus);
  return (
    <>
      <Card
        className="gg-border-b gg-border-t gg-px-4 sm:gg-px-14 2xl:gg-px-32"
        shadow={false}
      >
        <section className="gg-grid gg-grid-cols-12">
          <>
            <div className="gg-col-span-12 gg-grid gg-grid-cols-12 gg-border-t gg-py-14">
              {isLoading ? (
                // Skeleton for header
                <div className="gg-col-span-12 lg:gg-col-span-4">
                  <Skeleton className="gg-mb-8 gg-h-56 gg-w-full lg:gg-w-[75%]" />
                </div>
              ) : bumbalAlreadyPlanned ? (
                // Header for already planned
                <AlreadyPlannedHeader />
              ) : (
                // Header for calendar
                <CheckoutPanelDatePickerHeader className="gg-col-span-12 gg-mb-10 lg:gg-col-span-4 lg:gg-mb-0 lg:gg-pr-10 xl:gg-pr-24" />
              )}

              {/* Calendar / Skeleton / AlreadyPlanned */}

              {isLoading ? (
                // Skeleton for calendar
                <div className="gg-col-span-12 lg:gg-col-span-8">
                  <Skeleton className="gg-h-[500px] gg-w-full" />
                </div>
              ) : bumbalAlreadyPlanned ? (
                // Already planned texts
                <StandardProductRecommendations />
              ) : (
                // Calendar
                <CheckoutPanelShipmentDeliveryDatePicker
                  order_id={standardOrderId}
                  key={bumbalType}
                  bumbalType={bumbalType}
                  setDate={setDate}
                  selectedDateProp={selectedDateProp}
                  formattedDate={formattedDate}
                />
              )}
            </div>
          </>
        </section>
      </Card>

      {/* Footer */}
      <StandardOrderAppointmentFooter
        date={date}
        standardOrderId={standardOrderId}
        bumbalType={bumbalType}
        bumbalAlreadyPlanned={bumbalAlreadyPlanned}
      />
    </>
  );
};
